import { useState } from 'react'
import HomePage from './pages/Homepage'
import Header from './pages/Header'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import ProductsPage from './pages/Products'
import Footer from './Components/Footer'
function App() {

  return (
    <>
    <BrowserRouter>
    <Header/>
        <Routes>
          <Route path='/' element={<HomePage/>}/>
          <Route path='/products' element={<ProductsPage/>}/>
        </Routes>
    <Footer/>
    </BrowserRouter>

    </>
  )
}

export default App
